module.exports = __webpack_public_path__ + "static/img/9.0c1be4d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/2/1/sp/9.png
// module id = c4BF
// module chunks = 0